import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import './styles/site.css'
import router from './router'
import rise, { motionSupported } from './js/rise'
// import Argon from "./plugins/argon-kit";

if (motionSupported) document.documentElement.classList.add('is-motion');

createApp(App).use(router).directive('rise', rise).mount('#app')
